export default {
    parts: [
        'container',
        'sidebarTitle',
        'folderList',
        'folderItem',
        'folderItemActive',
        'folderName',
        'folderCount',
        'formModalContent',
        'formModalBody',
        'mobileNavContainer',
        'mobileScrollContainer',
        'mobileFolderItem',
        'mobileFolderItemActive'
    ],
    baseStyle: {
        container: {
            // Desktop: static sidebar column; Mobile: full-width above grid
            w: '100%'
        },
        sidebarTitle: {
            textStyle: 'webH3',
            pb: '24px',
            borderBottom: '1px solid',
            borderColor: 'webTheme.strokeTertiary',
            mb: '24px'
        },
        folderList: {
            // Desktop only: vertical list
            flexDirection: 'column',
            gap: '16px'
        },
        folderItem: {
            display: 'flex',
            alignItems: 'center',
            flexShrink: 0,
            cursor: 'pointer',
            textDecoration: 'none',
            color: 'webTypo.textSecondary',
            _hover: {
                textDecoration: 'none',
                color: 'webTypo.textPrimary'
            }
        },
        folderItemActive: {
            color: 'webTypo.textPrimary'
        },
        folderName: {
            whiteSpace: 'nowrap'
        },
        folderCount: {
            whiteSpace: 'nowrap'
        },
        formModalContent: {
            mx: {base: 4, lg: 0}
        },
        formModalBody: {
            pb: 6
        },
        mobileNavContainer: {
            display: {base: 'block', lg: 'none'},
            mt: 4,
            mb: 4,
            w: '100%',
            minW: 0
        },
        mobileScrollContainer: {
            display: 'flex',
            overflowX: 'auto',
            w: '100%',
            minW: 0,
            gap: '16px',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            '&::-webkit-scrollbar': {display: 'none'},
            WebkitOverflowScrolling: 'touch'
        },
        mobileFolderItem: {
            flexShrink: 0,
            textStyle: 'labelXs',
            p: '8px',
            pb: '10px',
            color: 'webTypo.textPrimary',
            borderBottom: '1px solid transparent',
            borderColor: 'transparent',
            whiteSpace: 'nowrap',
            textDecoration: 'none',
            cursor: 'pointer',
            _hover: {textDecoration: 'none', color: 'webTypo.textPrimary'}
        },
        mobileFolderItemActive: {
            fontWeight: 'bold',
            color: 'webTypo.textPrimary',
            borderBottom: '1px solid',
            borderColor: 'webTheme.strokeDefault'
        }
    }
}

